<template>
  <div>
    <Dialog
      :id="'dialogListSessao'"
      ref="dialogListSessao"
      :hide-header="true"
      :hideFooter="true"
      :modal="true"
      :tamanho="'xl'"
      :classModalBody="'mx-5 mx-xl-1 my-1'"
      @dialog-off="
        $emit('dialog-off');
        fechar();
      "
    >
      <SessaoList
        ref="listSessao"
        :dialog="true"
        @dialog-on="fechar()"
        @dialog-off="
          filtroNuvem == ''
            ? abrir(filtroCliente, true)
            : abrirNuvem(filtroCliente, filtroNuvem, true)
        "
        :buttonNovo="buttonNovo"
        :buttonSelecionar="buttonSelecionar"
        :sysadmin="sysadmin"
      />

      <template #header>
        <div class="m-9 mb-0">
          <div class="d-flex justify-content-between">
            <div>
              <h1 class="d-flex text-dark fw-bolder fs-2 mt-2">Sessões</h1>
            </div>

            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1" @click="$emit('dialog-off')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.5"
                    x="6"
                    y="17.3137"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(-45 6 17.3137)"
                    fill="currentColor"
                  ></rect>
                  <rect
                    x="7.41422"
                    y="6"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(45 7.41422 6)"
                    fill="currentColor"
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div class="separator m-0 mt-3" v-if="true"></div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";

import SessaoList from "./SessaoList.vue";
import Dialog from "../components/ComponentDialog.vue";

export default {
  components: { SessaoList, Dialog },
  props: {
    buttonSelecionar: { type: Boolean, default: false },
    sysadmin: { type: Boolean, default: false }
  },

  data() {
    return {
      nomeCliente: "",
      nomeNuvem: "",
      filtroCliente: "",
      filtroNuvem: ""
    };
  },

  mounted() {},

  methods: {
    abrir(cliente, interno = false) {
      if (!interno) {
        this.$emit("dialog-on");
      }

      this.filtroCliente = cliente;
      this.filtroNuvem = "";
      this.$refs.listSessao.filtroCliente = this.filtroCliente;
      this.$refs.listSessao.filtroNuvem = this.filtroNuvem;
      this.$refs.listSessao.carregarItens();
      this.$refs.dialogListSessao.abrir();

      if (!interno) {
        this.$emit("dialog-on");
      }
    },
    async abrirNuvem(cliente, nuvem, interno) {
      //* Limpa os campos
      this.nomeCliente = "-";
      this.nomeNuvem = "-";

      //* Carrega os dados da api
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/nuvem/" + nuvem
      );

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        const itemNuvem = response.data.itens[0];
        this.nomeCliente = itemNuvem.cliente ? itemNuvem.cliente.nome : "-";
        this.nomeNuvem = itemNuvem.nome;

        if (!interno) {
          this.$emit("dialog-on");
        }

        this.filtroCliente = cliente;
        this.filtroNuvem = nuvem;

        //* Passa para a lista os totais
        this.$refs.listSessao.estatisticas.espacoTotal = itemNuvem.espacoTotal;
        this.$refs.listSessao.estatisticas.espacoUtilizado =
          itemNuvem.espacoOcupado;
        this.$refs.listSessao.estatisticas.usuariosTotal =
          itemNuvem.usuariosTotal;
        this.$refs.listSessao.estatisticas.usuariosUtilizado =
          itemNuvem.usuarios.length;

        this.$refs.listSessao.filtroCliente = this.filtroCliente;
        this.$refs.listSessao.filtroNuvem = this.filtroNuvem;

        this.$refs.listSessao.carregarItens();
        this.$refs.dialogListSessao.abrir();
      }
    },
    fechar() {
      this.$refs.dialogListSessao.fechar();
    }
  }
};
</script>

<style></style>
